import { TextAreaEditor } from '@approvalmax/ui';
import { Flex } from '@approvalmax/ui/src/components';
import { constants } from 'modules/common';
import { domain } from 'modules/data';
import { useShallowEqualSelector } from 'modules/react-redux';
import { changeQbooksCustomerMemo, changeQbooksMemo } from 'pages/requestForm/actions';
import { SectionContainer } from 'pages/requestForm/components/SectionContainer';
import { getRequest } from 'pages/requestForm/selectors/pageSelectors';
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { messages } from './SalesInvoiceMessagesSection.messages';

export const SalesInvoiceMessagesSection = memo(() => {
    const dispatch = useDispatch();

    const { memo, customerMemo } = useShallowEqualSelector((state) => {
        const request = getRequest<domain.QBooksInvoiceRequest>(state);
        const details = request.details;

        return {
            memo: details.memo,
            customerMemo: details.customerMemo,
        };
    });

    const handleCustomerMemoChange = useCallback(
        (value: string) => {
            dispatch(changeQbooksCustomerMemo(value));
        },
        [dispatch]
    );

    const handleMemoChange = useCallback(
        (value: string) => {
            dispatch(changeQbooksMemo(value));
        },
        [dispatch]
    );

    return (
        <SectionContainer
            title={
                <Flex container spacing='0 20'>
                    <Flex size={12} block>
                        {messages.customerMemoTitle}
                    </Flex>

                    <Flex size={12} block>
                        {messages.memoTitle}
                    </Flex>
                </Flex>
            }
        >
            <Flex container spacing='0 20'>
                <Flex size={12} block>
                    <TextAreaEditor
                        minHeight={4}
                        maxHeight={12}
                        maxLength={constants.qBooksConstants.CUSTOMER_MEMO_MAX_LENGTH}
                        value={customerMemo}
                        onChange={handleCustomerMemoChange}
                        placeholder={messages.customerMemoPlaceholder}
                        changeOnBlur
                    />
                </Flex>

                <Flex size={12} block>
                    <TextAreaEditor
                        minHeight={4}
                        maxHeight={12}
                        maxLength={constants.qBooksConstants.MEMO_MAX_LENGTH}
                        value={memo}
                        onChange={handleMemoChange}
                        placeholder={messages.memoPlaceholder}
                        changeOnBlur
                    />
                </Flex>
            </Flex>
        </SectionContainer>
    );
});

SalesInvoiceMessagesSection.displayName = 'SalesInvoiceMessagesSection';
